/**
 * Optimize Essential Upsell app block images: request CDN size matching display (64px → 128px for 2x).
 * Runs early and observes DOM so app-injected images get smaller src before load.
 */
(function () {
  var TARGET_WIDTH = 128;
  var SEL = 'img[data-essential-upsell-element="image"]';

  function setOptimizedSrc(img) {
    var src = img.getAttribute('src');
    if (!src || img.dataset.essentialUpsellOptimized === 'true') return;
    var url;
    try {
      url = new URL(src, window.location.origin);
    } catch (e) {
      return;
    }
    url.searchParams.set('width', String(TARGET_WIDTH));
    var newSrc = url.toString();
    if (newSrc !== src) {
      img.setAttribute('src', newSrc);
      img.dataset.essentialUpsellOptimized = 'true';
    }
  }

  function processImages(root) {
    var el = root && root.querySelector ? root : document;
    var imgs = el.querySelectorAll ? el.querySelectorAll(SEL) : [];
    for (var i = 0; i < imgs.length; i++) setOptimizedSrc(imgs[i]);
  }

  function run() {
    processImages(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  var observer = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var list = mutations[m].addedNodes;
      for (var i = 0; i < list.length; i++) {
        var node = list[i];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(SEL)) setOptimizedSrc(node);
        if (node.querySelector) processImages(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  var attrObserver = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var target = mutations[m].target;
      if (target.matches && target.matches(SEL)) setOptimizedSrc(target);
    }
  });
  attrObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['src'],
    subtree: true
  });

  console.log("working fine");
  
})();
